/* eslint-disable multiline-comment-style */
import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

// 登录
// 用户登录信息
export interface ILoginInfo {
  // 登录用户名-邮箱
  userName: string;
  // 登录密码
  password: string;
}
export const userLogin = async ({ userName, password }: ILoginInfo) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/login`,  { userName, password })

interface SSOLoginInfo {

  /** 员工mis号，密文 */
  mis: string;

  /** 员工姓名，密文 */
  name: string;

  /** 企业id，密文 */
  entId: string;

  /** 时间戳，密文 */
  timeStamp: string;
}

export const ssoLogin = async (params: SSOLoginInfo) => request.post(`${HOSTS.BASE}/api/entweb/entAdmin/ossLogin`,  params)

export const getLoginPublicKey = async () => request.get<string>(`${HOSTS.BASE}/api/entweb/getPublicKey`)
